import {
  Box,
  Typography,
  useTheme,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  Button,
  MenuItem,
  Alert,
} from "@mui/material";
import { useState } from "react";
import { tokens } from "../../theme";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import Header from "../../components/Header";
import Customization from "../../../src/scenes/nftTokenGatingData/components/customization";

const TokenGatingData = () => {
  const theme = useTheme();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();

  //stores data for page based token gating
  const [pageBasedTokenGatingData, setpageBasedTokenGatingData] = useState(
    location.state.pageBasedTokenGatingData
  );
  //stores data for full site token gating
  const [contractAddressForFullSite, setContractAddressForFullSite] = useState(
    location.state.contractAddressForFullSite
  );
  const [tokenIdForFullSite, setTokenIdForFullSite] = useState(
    location.state.tokenIdForFullSite
  );
  const [nftsRequiredForFullSite, setNftsRequiredForFullSite] = useState(
    location.state.nftsRequiredForFullSite
  );

  //stores data of other nft token gating input fields required
  const [nftTokenGatingInputFields, setNftTokenGatingInputFields] = useState({
    serverUrl: location.state.serverUrl,
    domainName: location.state.domainName,
    isFullSiteOrPageBasedTokenGating:
      location.state.isFullSiteOrPageBasedTokenGating,
  });

  const onHandleCustomLogo = async (event) => {
    const data = event.target.files[0];
    if (data.size > 2 * 1000000) {
      swal({
        title: "Size is greater than 2 MB.",
        icon: "error",
      });
    }
    const { name, value } = event.target;
    const formData = new FormData();
    formData.append("image", data);
    let response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/upload-logo`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    });

    let imageId = response.data.response;
    let imagePath = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}` + "/uploads/" + imageId,
    });
    imagePath = imagePath.config.url;
    imagePath = imagePath.replace(/\\/g, "/");
    setNftCustomizationDetails({
      ...nftCustomizationDetails,
      [name]: imagePath,
    });
  };

  //handles branding details
  const [nftCustomizationDetails, setNftCustomizationDetails] = useState(
    location.state.nftCustomizationDetails
      ? location.state.nftCustomizationDetails
      : {
          connectWalletButtonColor: "#d9534f",
          connectWalletButtonText: "Connect Wallet",
          connectWalletButtonTextColor: "#ffffff",
          buyNFTButtonColor: "#5cb85c",
          buyNFTButtonText: "Buy NFT",
          buyNFTButtonTextColor: "#ffffff",
          restrictedContentMessageHeader: "Access to this page is restricted",
          restrictedContentMessage:
            "Please login with your crypto wallet to verify your NFT ownership",
          errorMessageHeader: "You are not authorized to access this site",
          errorMessage: "The NFT is required to view this page",
          linkToBuyNft: "https://opensea.io",
          homePageRedirectionLink: "/",
          customLogo: process.env.REACT_APP_BASE_URL + "/default-logo",
        }
  );

  const onHandleNftCustomizationInputChange = (event) => {
    const { name, value } = event.target;
    setNftCustomizationDetails({
      ...nftCustomizationDetails,
      [name]: value,
    });
  };

  // Check if the single IP address is valid or not
  const IsIpAddressValid = (ipaddress) => {
    var ipformat =
      /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
    return ipformat.test(ipaddress);
  };

  const IsValidDomain = (domain) => {
    // Regular expression to match a valid domain format
    const domainPattern = /^(?!:\/\/)([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}$/;
    return domainPattern.test(domain);
  };

  const [domainErrorMessage, setDomainErrorMessage] = useState(false);
  const [ipErrorMessage, setIpErrorMessage] = useState(false);

  //handles input changes for nft token gating data
  const onHandleNftTokenGatingInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "serverUrl") {
      const isIpAddressValid = IsIpAddressValid(value);
      if (!isIpAddressValid) {
        setIpErrorMessage(true);
      } else {
        setIpErrorMessage(false);
      }
    }

    if (name === "domainName") {
      const isValidDomain = IsValidDomain(value);
      if (!isValidDomain) {
        setDomainErrorMessage(true);
      } else {
        setDomainErrorMessage(false);
      }
    }

    setNftTokenGatingInputFields({
      ...nftTokenGatingInputFields,
      [name]: value,
    });
  };
  //handles input changes for page based token gating data
  const onHandleInputChangeForPageBased = (event, index) => {
    const { name, value } = event.target;
    const listOfPagePaths = [...pageBasedTokenGatingData];
    listOfPagePaths[index][name] = value;
    setpageBasedTokenGatingData(listOfPagePaths);
  };
  //removes page path field if remove button clicked dynamically
  const handleRemoveClick = (index) => {
    const listOfPagePaths = [...pageBasedTokenGatingData];
    listOfPagePaths.splice(index, 1);
    setpageBasedTokenGatingData(listOfPagePaths);
  };
  //adds more page path field if add button clicked dynamically
  const handleAddClick = () => {
    setpageBasedTokenGatingData([
      ...pageBasedTokenGatingData,
      {
        pagePath: "",
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };
  //clears data
  const handleClearDataForPageBased = () => {
    setpageBasedTokenGatingData([
      {
        pagePath: "",
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };
  //clears data

  const gotoPreviousPage = () => {
    navigate("/configured-apps");
  };

  const onNftTokenGatingDataSubmit = (event) => {
    event.preventDefault();
    if (!domainErrorMessage && !ipErrorMessage) {
      for (let i = 0; i < pageBasedTokenGatingData.length; i++) {
        let pageBasedContent = pageBasedTokenGatingData[i];
        pageBasedContent["pagePath"] = pageBasedContent["pagePath"].trim();
        pageBasedContent["contractAddress"] =
          pageBasedContent["contractAddress"].trim();
        pageBasedContent["tokenId"] = pageBasedContent["tokenId"].trim();
        pageBasedContent["nftsRequired"] =
          pageBasedContent["nftsRequired"].trim();
        pageBasedContent["tokenStandard"] =
          pageBasedContent["tokenStandard"].trim();
        pageBasedContent["blockChain"] = pageBasedContent["blockChain"].trim();
        pageBasedTokenGatingData[i] = pageBasedContent;
      }
      let nftTokenGatingData = {
        site: location.state.site,
        serverUrl: nftTokenGatingInputFields.serverUrl.trim(),
        domainName: nftTokenGatingInputFields.domainName.trim(),
        isFullSiteOrPageBasedTokenGating:
          nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating,
        contractAddressForFullSite: contractAddressForFullSite,
        pageBasedTokenGatingData: pageBasedTokenGatingData,
        tokenIdForFullSite: tokenIdForFullSite,
        nftsRequiredForFullSite: nftsRequiredForFullSite,
        nftCustomizationDetails: nftCustomizationDetails,
      };

      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/nft-token-gating-edit`,
          {
            nftTokenGatingData,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
              customer_id: location.state._id,
            },
          }
        )
        .then((res) => {
          swal({
            title: "Edited!",
            text: res.data.title,
            icon: "success",
            // type: "success",
          });
          navigate("/configured-apps");
        })
        .catch((err) => {
          swal({
            text: err.response.data.errorMessage,
            icon: "error",
            // type: "error",
          });
        });
    }
  };

  return (
    <Box
      m="20px"
      ml="90px"
      sx={{ boxShadow: "15" }}
      mr="90px"
      paddingLeft="75px"
      paddingTop="10px"
    >
      <Header title="Token Gating" subtitle="Fill the required field" />
      <Box
        sx={{
          mt: 1,
          width: 900,
          "& Grid": {
            color: colors.greenAccent[300],
          },
        }}
      >
        <form onSubmit={onNftTokenGatingDataSubmit}>
          <Grid container rowSpacing={2} columnSpacing={2} sx={{ mt: 3 }}>
            <Grid item md={6} sm={6} xs={6}>
              <Typography
                component="h6"
                variant="h5"
                color="#000080"
                sx={{ mt: -1, mb: 2 }}
              >
                <b>Selected Application</b>
              </Typography>
              <TextField
                sx={{ boxShadow: 2 }}
                fullWidth
                // size="small"
                value={location.state.site}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={6}>
              <Typography
                component="h6"
                variant="h5"
                color="#000080"
                sx={{ mt: -1, mb: 2 }}
              >
                <b>Domain Name</b>
              </Typography>
              <TextField
                required
                fullWidth
                name="domainName"
                label="Enter the domain name without http or https. Example: www.abc.com "
                type="text"
                id="domainName"
                autoComplete="name"
                disabled={location.state.sslCertsPresent}
                //  size="small"
                sx={{ boxShadow: 2 }}
                value={nftTokenGatingInputFields.domainName}
                onChange={onHandleNftTokenGatingInputChange}
              />
              {domainErrorMessage && (
                <Typography color="red" fontSize="14" sx={{ mt: 0.5 }}>
                  Please Provide a valid Domain.
                </Typography>
              )}
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography
                component="h6"
                variant="h5"
                color="#000080"
                sx={{ mb: 2 }}
              >
                <b>Server IP</b>
              </Typography>
              <TextField
                required
                fullWidth
                name="serverUrl"
                label="Enter the selected platform Server URL"
                type="text"
                id="serverUrl"
                autoComplete="name"
                // size="small"
                sx={{ boxShadow: 2 }}
                value={nftTokenGatingInputFields.serverUrl}
                onChange={onHandleNftTokenGatingInputChange}
              />
              {ipErrorMessage && (
                <Typography color="red" fontSize="14" sx={{ mt: 0.5 }}>
                  Please Provide a valid IP address.
                </Typography>
              )}
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography
                component="h6"
                variant="h5"
                color="#000080"
                sx={{ mb: 2 }}
              >
                <b>Token Gating Info</b>
              </Typography>
              <FormControl
                sx={{ boxShadow: 2 }}
                //size="small"
                fullWidth
                required
              >
                <InputLabel id="demo-simple-select-label">
                  Token Gating
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="isFullSiteOrPageBasedTokenGating"
                  label="Token Gating"
                  onChange={onHandleNftTokenGatingInputChange}
                  value={
                    nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating
                  }
                  // size="small"
                >
                  <MenuItem
                    value={"Full Site"}
                    onClick={() => handleClearDataForPageBased()}
                  >
                    Full site Token Gating
                  </MenuItem>
                  <MenuItem
                    value={"Page Based"}
                    onClick={() => handleClearDataForPageBased()}
                  >
                    Page Based Token Gating
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {(nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating ==
              "Page Based" ||
              nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating ==
                "Full Site") &&
              pageBasedTokenGatingData.map((currentElement, index) => {
                return (
                  <Grid container key={index} direction="row">
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ mt: 2, ml: 7, boxShadow: 2 }}
                        fullWidth
                        required
                        name="pagePath"
                        value={currentElement.pagePath}
                        label="page path"
                        type="text"
                        // size="small"
                        id="pagePath"
                        autoComplete="name"
                        onChange={(event) =>
                          onHandleInputChangeForPageBased(event, index)
                        }
                      />
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <FormControl
                        sx={{ ml: 8, mt: 2, boxShadow: 2 }}
                        // size="small"
                        fullWidth
                      >
                        <InputLabel id="demo-simple-select-label">
                          Select BlockChain
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="blockChain"
                          label="Select BlockChain"
                          // size="small"
                          value={currentElement.blockChain}
                          onChange={(event) =>
                            onHandleInputChangeForPageBased(event, index)
                          }
                        >
                          <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
                          <MenuItem value={"Polygon"}>Polygon</MenuItem>
                          <MenuItem value={"POAP/xDai"}>POAP/xDAI</MenuItem>
                          <MenuItem value={"Sepolia-Ethereum"}>
                            Sepolia Ethereum
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <FormControl
                        sx={{ ml: 9, mt: 2, boxShadow: 2 }}
                        // size="small"
                        fullWidth
                      >
                        <InputLabel id="demo-simple-select-label">
                          Token Standard
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="tokenStandard"
                          label="Enter Smart Contract Token Standard"
                          //   size="small"
                          value={
                            currentElement.blockChain == "POAP/xDai"
                              ? (currentElement.tokenStandard = "ERC721")
                              : currentElement.tokenStandard
                          }
                          onChange={(event) =>
                            onHandleInputChangeForPageBased(event, index)
                          }
                          disabled={
                            currentElement.blockChain == "POAP/xDai"
                              ? true
                              : false
                          }
                        >
                          <MenuItem value={"ERC20"}>ERC20</MenuItem>
                          <MenuItem value={"ERC721"}>ERC721</MenuItem>
                          <MenuItem value={"ERC1155"}>ERC1155</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={1} xs={1} sm={1}>
                      {
                        <Button
                          className="custom-color-button"
                          size="small"
                          disabled={
                            pageBasedTokenGatingData.length - 1 === index
                              ? false
                              : true
                          }
                          variant="contained"
                          sx={{ mt: 6, ml: 11 }}
                          onClick={handleAddClick}
                          color="info"
                        >
                          Add
                        </Button>
                      }
                    </Grid>
                    <Grid item md={1} xs={1} sm={1}>
                      {
                        <Button
                          size="small"
                          disabled={
                            pageBasedTokenGatingData.length == 1 ? true : false
                          }
                          variant="contained"
                          sx={{ mt: 6, ml: 10, fontFamily: "Poppins" }}
                          onClick={() => handleRemoveClick(index)}
                          color="error"
                        >
                          Remove
                        </Button>
                      }
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 7, boxShadow: 2, mt: 1 }}
                        fullWidth
                        required
                        name="contractAddress"
                        value={currentElement.contractAddress}
                        label={
                          currentElement.blockChain == "POAP/xDai"
                            ? "Event ID"
                            : "Contract Address"
                        }
                        type="text"
                        // size="small"
                        id="contractAddress"
                        autoComplete="name"
                        onChange={(event) =>
                          onHandleInputChangeForPageBased(event, index)
                        }
                      />
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 8, boxShadow: 2, mt: 1 }}
                        fullWidth
                        //required
                        name="tokenId"
                        value={currentElement.tokenId}
                        label="Token Id"
                        type="text"
                        // size="small"
                        id="tokenId"
                        autoComplete="name"
                        onChange={(event) =>
                          onHandleInputChangeForPageBased(event, index)
                        }
                      />
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 9, boxShadow: 2, mt: 1 }}
                        fullWidth
                        required
                        name="nftsRequired"
                        value={currentElement.nftsRequired}
                        label="Nfts/Tokens Required"
                        inputProps={{ type: "number", min: 1 }}
                        //  size="small"
                        id="nftsRequired"
                        autoComplete="name"
                        onChange={(event) => {
                          const value = event.target.value;
                          if (value === "" || value > 0) {
                            onHandleInputChangeForPageBased(event, index);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                );
              })}

            <Customization
              onHandleNftCustomizationInputChange={
                onHandleNftCustomizationInputChange
              }
              nftCustomizationDetails={nftCustomizationDetails}
              onHandleCustomLogo={onHandleCustomLogo}
            />

            <Grid item md={12} sm={12} xs={12}>
              <Alert severity="info" sx={{ fontFamily: "Poppins" }}>
                Note : Please point your CName to{" "}
                {process.env.REACT_APP_DOMAIN_NAME + " "}(
                {process.env.REACT_APP_IP_SERVER}) on DNS
              </Alert>
            </Grid>
            <Grid item md={10}>
              <Button
                className="custom-color-button"
                type="submit"
                size="small"
                variant="contained"
                color="info"
                sx={{ mt: 4, mb: 3 }}
              >
                Update
              </Button>
            </Grid>
            <Grid item md={2}>
              <Button
                className="custom-color-button"
                size="small"
                variant="contained"
                color="info"
                sx={{ mt: 4, mb: 3 }}
                onClick={gotoPreviousPage}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default TokenGatingData;
